import { nanoid } from "nanoid";
import { call, select, sleep, takeLeading } from "starfx";

import {
  CONST_XAPI_INSIDER_LOGOUT_NAME,
  PERSISTOR_NAME,
} from "@app/state/constants";
import { safeLast } from "@app/statefx/helpers";

// import { dateToSqlDate } from '@app/service/helpers';
import { isErr, isOk } from "../helpers";
import { runThunk } from "../helpers/fxhelpers";
import { schema } from "../schema";
import { terminateWorker } from "../workers/gxworker-factory";
import { getPxWorker } from "../workers/pxworker-factory";
import { xApi, xThunk } from "../xapis";
import { sfxDataBoot } from "./ds";
import { sfxNotify } from "./notify";
import { releaseLock } from "./prc-lock";

function* parseableCtx(ctx: ApiCtx) {
  yield* sleep(1);
  return ctx.json;
}

import type { Next, ApiCtx } from "starfx";
const db = schema;

import type { TInsLoginData } from "@app/types";
type TJGLoginParams = {
  email: string;
  perseed: string;
};

// in JGAP we skip this login as we already have the session
export const sfxInLogin = xApi.post<TJGLoginParams>(
  "xapi/insider/login",
  { supervisor: takeLeading },
  function* (ctx, next) {
    yield* schema.update(db.jgLogin.reset());
    const newSessionId = nanoid();
    ctx.request = ctx.req({
      method: "POST",
      url: `/login`,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        credentials: "include",
      },
      body: JSON.stringify({
        insider: ctx.payload.perseed,
        geml: ctx.payload.email,
        micro: newSessionId,
      }),
    });
    yield* next();
    const data = yield* safeLast(parseableCtx(ctx));
    if (isErr(data)) {
      yield* runThunk(sfxNotify, {
        type: "error",
        message: data.error?.message || "Eroare la logare",
        duration: 3000,
      });
    } else {
      const {
        AMA_ID,
        PRENUME,
        NUME,
        DREPT_SUPREM,
        DREPT_FACTURARE,
        INSIDER,
        LOGINCTX,
      } = data.value as any;

      yield* schema.update(
        db.jgLogin.set({
          AMAXAVOID: AMA_ID,
          INSIDER: INSIDER,
          DISPLAY_NAME: `${PRENUME} ${NUME}`,
          DREPT_SUPREM: DREPT_SUPREM,
          DREPT_FACTURARE: DREPT_FACTURARE,
          LOGINCTX: LOGINCTX,
        })
      );
      // fire up the startup
      yield* call(sfxDataBoot.run());
    }
    return;
  }
);

export const cleanupSfx = xThunk.create(
  "sfx/cleanup",
  { supervisor: takeLeading },
  function* () {
    yield* schema.update(db.appJobs.reset());
  }
);
// JGAP ONLY //
export const sfxCloneSagaLogin = xThunk.create<TInsLoginData>(
  "sfx/cloneSagaLogin",
  { supervisor: takeLeading },
  function* (ctx, next) {
    yield* schema.update(db.jgLogin.reset());
    yield* schema.update(db.jgLogin.set(ctx.payload));

    yield* schema.update(
      db.persistorGuardian.set({
        email: ctx.payload.EML,
        perseed: ctx.payload.INSIDER,
      })
    );
    const pxWorker = getPxWorker();
    if (pxWorker) {
      pxWorker.postMessage({
        type: "/upgrade",
        data: JSON.stringify({
          email: ctx.payload.EML,
          perseed: ctx.payload.INSIDER,
        }),
      });
    }

    yield* next();
  }
);

export const sfxInLogout = xApi.post(
  CONST_XAPI_INSIDER_LOGOUT_NAME, // <<< don't change this /// !!! ///
  { supervisor: takeLeading },
  function* (ctx, next) {
    const currentLogin = yield* select(db.jgLogin.select);
    if (!currentLogin.LOGINCTX) {
      return;
    }
    // const currentLoginCtx = currentLogin.LOGINCTX;
    ctx.request = ctx.req({
      method: "POST",
      url: `/logout`,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        credentials: "include",
      },
      body: JSON.stringify({ u: "any" }),
    });
    yield* next();

    yield* schema.update(db.jgLogin.reset());
    yield* schema.update(db.profileGroup.reset());
    yield* schema.update(db.whoami.reset());
    yield* releaseLock();

    //todo: https://github.com/VldMrgnn/jgap/issues/19 send abort signal to the worker
    // yield* sleep(900);
    // terminateWorker();

    return;
  }
);
